<template>
  <div class="coupon-container">
    <div class="usercenter-title">
      <h4 v-if="airline === 'JD'">我的优惠券</h4>
      <h4 v-else>我的卡券</h4>
    </div>
    <div class="mod-form">
      <a-form :form="form" layout="inline" @submit="handleSubmit">
        <a-form-item :label="airline === 'JD' ? '优惠券兑换码' : '我的卡券号'">
          <a-input v-model.trim="couponNo" />
        </a-form-item>
        <a-form-item label="激活密码">
          <a-input v-model.trim="password" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit" :loading="activeLoading">
            激活
          </a-button>
        </a-form-item>
        <a-form-item v-if="agreeList.length">
          <AgreementTrack
           :checked="couponAgreement"
           :cmsId="agreeListModuleId"
           description='卡券列表页（激活）'
           pageName='hna_coupon_active'
           @change="e => couponAgreement = e">
            我已阅读并同意
            <template v-for="(item, index) in agreeList">
              <router-link :to="item.url" :key="index" target="_blank">{{ item.name }}{{ index === (agreeList.length - 1) ? '' : '，'}}</router-link>
            </template>
          </AgreementTrack>
        </a-form-item>
      </a-form>
    </div>
    <div class="coupon-body">
      <a-tabs :default-active-key="activeKey" @change="onTab">
        <a-tab-pane key="1" tab="未使用">
          <use-table
            :loading="loading"
            :data="data"
            @change="onUseTableChange"
            ref="useTable"
          ></use-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="已使用">
          <used-table
            :loading="loading"
            :data="data"
            @change="onUsedTableChange"
            @detail="onShowDetail"
          ></used-table>
        </a-tab-pane>
        <a-tab-pane key="6" tab="已失效">
          <expired-table
            :loading="loading"
            :data="data"
            @change="onExpiredTableChange"
            @detail="onShowDetail"
          ></expired-table>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="mod-tips" v-if="cardCouponTips" v-html="cardCouponTips">
    </div>
    <a-modal
      title="卡券详情"
      :visible="visible"
      width="640px"
      @cancel="visible = false"
    >
      <a-spin :spinning="detailLoading" size="large">
        <div class="empty" v-if="!couponDetail">
          暂无数据
        </div>
        <template v-else>
          <div class="mod-coupon-detail">
            <table>
              <colgroup>
                <col>
                <col>
                <col>
                <col>
                <col>
              </colgroup>
              <tbody>
                <tr>
                  <td colspan="2">卡券号</td>
                  <td colspan="1">卡券类型</td>
                  <td colspan="1">优惠类型</td>
                  <td colspan="1">优惠值</td>
                  <td colspan="1">最大优惠金额</td>
                </tr>
                <tr>
                  <td colspan="2">{{ couponDetail.couponCode }}</td>
                  <td colspan="1">{{ couponDetail.type | cardType }}</td>
                  <td colspan="1">{{ couponDetail.preferentialType | couponType }}</td>
                  <td colspan="1" v-if="couponDetail.preferentialType === 0">{{ `${couponDetail.preferentialValue}元` }}</td>
                  <td colspan="1" v-else>{{ `${couponDetail.preferentialValue*10}折` }}</td>
                  <td colspan="1">{{ couponDetail.maxAmount }}元</td>
                </tr>
                <tr>
                  <td colspan="3">优惠券有效期</td>
                  <td colspan="2">领取时间</td>
                  <td colspan="1">转赠次数</td>
                </tr>
                <tr>
                  <td colspan="3">{{ `${couponDetail.startDate} - ${couponDetail.endDate}` }}</td>
                  <td colspan="2">{{ couponDetail.receiveTime }}</td>
                  <td colspan="1">{{ couponDetail.giveNum === 0 ? '不可转赠' : couponDetail.giveNum }}</td>
                </tr>
                <tr>
                  <td colspan="6">备注</td>
                </tr>
                <tr>
                  <td colspan="6">{{ couponDetail.remark || '-'  }}</td>
                </tr>
              </tbody>
            </table>
            <div class="tip" v-if="couponDetail.couponRuleDetails">
              <h6>用券须知<span v-if="couponDetail.couponRuleDetails.length > 1">（满足以下任意条件即可使用）</span>：</h6>
              <div v-for="(rItem, rIndex) in couponDetail.couponRuleDetails" :key="rIndex">
                <span v-if="couponDetail.couponRuleDetails.length > 1">{{ rIndex + 1 }}.</span>
                <span style="white-space: pre-wrap;" v-html="rItem.desc"></span>
              </div>
            </div>
          </div>
        </template>
      </a-spin>
      <template slot="footer">
        <a-button type="primary" @click="visible = false">
          确认
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import useTable from './components/useTable'
import usedTable from './components/usedTable'
import expiredTable from './components/expiredTable'
import AgreementTrack from '@/components/agreement-track'
import { userTypeMap } from '@/dicts/member'
import { couponType, cardType, source, couponStatus } from '@/filters/coupon'
import { queryMyCouponList, queryCouponDetail, bindingCardCoupon } from '@/apis/coupon'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}
const airline = mainSettings.airline

export default {
  data () {
    return {
      data: {
        list: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0
        }
      },
      couponNo: '',
      password: '',
      couponAgreement: false,
      loading: false,
      visible: false,
      couponDetail: {},
      activeKey: '1',
      couponCmsData: {},
      agreeList: [],
      agreeListModuleId: '',
      detailLoading: false,
      activeLoading: false,
      cardCouponTips: null,
      airline
    }
  },
  beforeCreate () {
    const user = window.__MICRO_ROOT__.user?.get()
    this.form = this.$form.createForm(this, { name: 'register' })

    if (userTypeMap[user.userType] === 'CARRIER' || userTypeMap[user.userType] === 'AGENT' || user.loginName === 'ETMOBILEUSER') {
      this.$modal.warning({
        title: '提示',
        content: '当前用户类型无法使用优惠券',
        okText: '确认',
        onOk: () => { this.$router.replace({ path: '/order/v2/search' }) }
      })
    }
  },
  mounted () {
    this.search({
      couponStatus: '1',
      couponType: 'TICKET',
      current: 1,
      pageSize: 12
    })
    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { cardCouponTips } = res
          this.cardCouponTips = cardCouponTips.content ?? ''
          this.agreeList = res?.['cardcoupon-agree']?.list || []
          this.agreeListModuleId = res?.['cardcoupon-agree']?._moduleId || ''
        })
      } catch (err) {}
    },
    async search (params) {
      this.loading = true

      params.pageNum = params.current
      delete params.current

      try {
        const data = await queryMyCouponList({
          ...params
        })
        let { result = [], pageNo = 1, pageSize, totalCount = 0 } = data

        this.loading = false
        // JD 过滤行李畅享卡券
        if (airline === 'JD') {
          result = result.filter(item => item.couponConfigProductCode !== 'FXL1')
        }
        this.data = {
          list: result || [],
          pagination: {
            current: pageNo,
            pageSize,
            total: totalCount
          }
        }
      } catch (err) {
        this.loading = false
        this.data = {
          list: [],
          pagination: {
            current: 1,
            pageSize: 10,
            total: 0
          }
        }
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }
    },
    async handleSubmit (e) {
      e && e.preventDefault()
      const { couponNo, password, agreeList, couponAgreement } = this

      if (!couponNo) {
        this.$message.error('请输入卡券号！')
        return
      }

      // if (!password) {
      //   this.$message.error('请输入激活密码！')
      //   return
      // }

      if (agreeList.length && !couponAgreement) {
        const agreeMentTitleGroup = agreeList?.map(item => { return item.name })?.join(',')
        this.$message.error(`请阅读并同意${agreeMentTitleGroup}！`)
        return
      }

      this.activeLoading = true
      try {
        await bindingCardCoupon({
          redeemCode: couponNo,
          password
        })
        this.activeLoading = false

        this.$message.success('激活成功')
        this.couponNo = ''
        this.password = ''
        this.search({
          couponStatus: this.activeKey,
          couponType: this.$refs.useTable.type,
          current: 1,
          pageSize: 12
        })
      } catch (err) {
        this.activeLoading = false
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }
    },
    onUseTableChange (type, pagination) {
      this.couponType = type
      this.search({
        couponType: type,
        couponStatus: '1',
        ...pagination
      })
    },
    onUsedTableChange (pagination) {
      this.search({
        couponStatus: '2',
        ...pagination
      })
    },
    onExpiredTableChange (pagination) {
      this.search({
        couponStatus: '6',
        ...pagination
      })
    },
    onTab (key) {
      this.activeKey = key
      this.data.list = []
      const params = {
        couponStatus: key,
        current: 1,
        pageSize: 10
      }

      if (key === 1) {
        params.couponType = 'TICKET'
        params.pageSize = 12
      }

      this.search(params)
    },
    async onShowDetail (code) {
      this.visible = true
      this.detailLoading = true
      try {
        this.couponDetail = await queryCouponDetail(code)
        this.detailLoading = false
      } catch (err) {
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }
    }
  },
  computed: {
    getAllowDetail () {
      return function (value, type) {
        return value ? value.map(item => { return item[type] }).join(',') : ''
      }
    }
  },
  filters: {
    couponType,
    cardType,
    source,
    couponStatus
  },
  components: {
    useTable,
    usedTable,
    expiredTable,
    AgreementTrack
  }
}
</script>
